<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      v-model="form"
      @search-change="searchChange"
      @search-reset="searchReset"
      @row-del="rowDel"
      :before-open="beforeOpen"
      :search.sync="query"
      :page.sync="page"
      @size-change="sizeChange"
      @current-change="currentChange"
      @refresh-change="onLoad"
    >
    </avue-crud>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="80%"
      append-to-body
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <Form
        v-if="dialogVisible"
        :project="query"
        :meterTypeList="meterTypeList"
        :dialogTitle="dialogTitle"
        :item="form"
        @save="save"
        @cancel="cancel"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import Form from "./form";
import { getDictionary } from "@/api/system/dict";
import { getProjectList } from "@/api/crmedical/project/project";
import {
  getList,
  warnsetSave,
  warnsetUpdate,
  warnsetRemove,
} from "@/api/crmedical/energy/alarm-setting";
export default {
  components: { Form },
  computed: {
    option() {
      return {
        searchMenuSpan: 6,
        index: true,
        indexLabel: "序号",
        viewBtn: true,
        emptyBtnText:'重置',
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            dicData: this.projectList,
            props: {
              label: "name",
              value: "id",
            },
            searchSpan: 6,
            search: true,
            searchClearable: false,
          },
          {
            label: "仪表名称",
            prop: "meterName",
            search: true,
            searchSpan: 6,
            hide: true,
          },
          {
            label: "仪表类型",
            prop: "meterType",
            search: true,
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            searchSpan: 6,
            dicData: this.meterTypeList,
          },
          {
            label: "关联仪表",
            prop: "relatedMeterNames",
            type: "select",
            searchSpan: 6,
            overHidden:true,
          },
        ],
      };
    },
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "查看",
      meterTypeList: [],
      projectList: [],
      query: {
        projectId: "",
      },
      form: {
        id: "",
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      data: [],
    };
  },
  created() {
    getDictionary({ code: "meter_type" }).then((res) => {
      this.meterTypeList = res.data.data;
    });
    getProjectList().then((res) => {
      this.projectList = res.data;
      this.setDefaultProjectId();
      this.onLoad();
    });
  },
  methods: {
    beforeOpen(done, type) {
      console.log("type==>", this.form);
      switch (type) {
        case "add":
          this.dialogTitle = "新增";
          break;
        case "edit":
          this.dialogTitle = "编辑";
          break;
        default:
          this.dialogTitle = "查看";
      }
      this.dialogVisible = true;
      // done();
    },
    save(data, title) {
      if (title == "新增") {
        warnsetSave(data)
          .then((res) => {
            console.log("res warnsetSave==>", res);
            this.dialogVisible = false;
            this.$message.success(res.msg);
            this.onLoad();
          })
          .catch((err) => {
            this.dialogVisible = false;
            // this.$message.error(err);
            console.log("err==>", err);
          });
      }
      if (title == "编辑") {
        warnsetUpdate(data)
          .then((res) => {
            console.log("res warnsetSave==>", res);
            this.dialogVisible = false;
            this.$message.success(res.msg);
            this.onLoad();
          })
          .catch((err) => {
            this.dialogVisible = false;
            // this.$message.error(err);
            console.log("err==>", err);
          });
      }
    },
    cancel() {
      this.dialogVisible = false;
      this.form = {};
    },
    rowDel(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return warnsetRemove({ ids: row.id });
        })
        .then((res) => {
          this.$message.success(res.msg);
          this.onLoad();
        })
        .catch((err) => {
          if (err == "cancel") {
            this.$message({
              type: "info",
              message: "已取消",
            });
          } else {
            this.$message({
              type: "error",
              message: err,
            });
          }
        });
    },
    searchChange(params, done) {
      this.onLoad();
      done();
    },
    searchReset() {
      this.setDefaultProjectId();
      this.onLoad();
    },
    sizeChange() {
      this.onLoad();
    },
    currentChange() {
      this.onLoad();
    },
    onLoad() {
      const params = this.query;
      params.current = this.page.currentPage;
      params.size = this.page.pageSize;
      getList(params).then((res) => {
        console.log("res getList==>", res);
        this.page.total = res.data.total;
        res.data.records.forEach((element) => {
          element.meterType += "";
          element.relatedMeterNames = element.meterList
            .map((ele) => ele.meterName)
            .toString();
        });
        this.data = res.data.records;
      });
    },
    setDefaultProjectId() {
      if (this.projectList.length > 0) {
        this.query.projectId = this.projectList[0].id;
      }
    },
  },
};
</script>

<style>
</style>